import request from './request'

export interface UpdateMobileParams {
  id: number
  phone_code: string
  phone: string
}

export interface TechnicianItem {
  id: number
  technician_no: string
  name: string
  avatar: string
  phone_code: string
  phone: string
  mobile: string
  work_role: string
  license_no: string
  sin_type: string
  sin_number: string
  residency_status: string
  address: string
  email: string
  status: number
  status_text: string
  settlement_config: Record<string, unknown>
  order_stats: {
    hmc_orders: number
    fu_orders: number
    ad_orders: number
  }
  upcoming_service: string | null
  create_time: string
  update_time: string
}

export interface UpdateMobileResponse {
  code: number
  msg: string
  data: {
    list: TechnicianItem[]
    pagination: {
      page: number
      page_size: number
      total: number
      total_pages: number
    }
  }
}

export async function updateMobile(data: UpdateMobileParams): Promise<UpdateMobileResponse> {
  return request.post<UpdateMobileResponse>(
    '/api/admin/technician/update-mobile',
    data,
  )
}
